import { cn } from "@/lib/utils"

const CORNERS = [
  ["top-1.5 left-1.5", "border-t border-l"],
  ["top-1.5 right-1.5", "border-t border-r"],
  ["bottom-1.5 left-1.5", "border-b border-l"],
  ["bottom-1.5 right-1.5", "border-b border-r"],
] as const

export function CornerTicks() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0">
      {CORNERS.map(([pos, border]) => (
        <span
          key={pos}
          className={cn("absolute size-3 border-white/40", pos, border)}
        />
      ))}
    </div>
  )
}
